export default "__VITE_ASSET__DaEqMUqP__"